export enum RequestTypeEnum {
    update = 0,
    setup = 1,
  }
